exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-45a23a50] .el-loading-mask{background-color:rgba(0,0,0,.5)!important}", ""]);

// exports
